export const enum OssType {
  NATIVE_VAT = 2,
  OSS_VAT = 1,
}
